import React from 'react'

const Header = () => {
  return (
    <div className='gridHeader'>
        <img src='https://gis.northcharleston.org/graphics/logo.png' alt='North Charleston Road Closures'></img>
        <h1>Road Closures</h1>
    </div>
  )
}

export default Header